var _rect, _path, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.6001,
    width: 44.8,
    height: 56,
    rx: 4,
    fill: "#F1EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.492 28.5808C38.7214 27.0375 36.0893 26.0705 32.4471 24.7319L31.3196 24.3119C31.27 24.2934 31.2271 24.2603 31.1966 24.217C31.1661 24.1738 31.1493 24.1223 31.1484 24.0694V21.8415C31.1484 21.8045 31.1562 21.7679 31.1712 21.7341C31.1862 21.7003 31.2081 21.67 31.2356 21.6452C32.0737 20.8964 32.5986 19.859 32.7054 18.7401C32.7107 18.6795 32.7371 18.6226 32.78 18.5795C33.0176 18.3121 33.179 17.9857 33.2472 17.6345C33.3446 17.2929 33.3651 16.9338 33.3072 16.5833C33.2493 16.2327 33.1144 15.8994 32.9123 15.6072C32.8828 15.5706 32.8636 15.5268 32.8566 15.4803C32.8495 15.4338 32.855 15.3863 32.8724 15.3426C33.5629 13.9568 33.8706 12.4116 33.7637 10.8669C33.4152 9.12614 30.9615 8.45316 28.9667 8.40276C27.3068 8.36707 25.2564 8.72928 24.5477 9.83483C24.5277 9.86624 24.5012 9.89306 24.4701 9.91351C24.439 9.93396 24.4039 9.94757 24.3671 9.95347C24.1073 9.98436 23.8564 10.0675 23.6296 10.198C23.4028 10.3285 23.2047 10.5035 23.0474 10.7125C21.9576 12.1824 23.1944 15.4371 23.1618 15.3321C23.1746 15.3744 23.1766 15.4193 23.1676 15.4625C23.1587 15.5058 23.139 15.5462 23.1104 15.5799C22.8987 15.8723 22.7562 16.2091 22.6937 16.5646C22.6311 16.9202 22.6501 17.2853 22.7492 17.6324C22.8174 17.9836 22.9788 18.31 23.2164 18.5774C23.2594 18.6204 23.2858 18.6773 23.291 18.738C23.3977 19.8569 23.9226 20.8943 24.7608 21.6431C24.7887 21.668 24.811 21.6986 24.8262 21.7328C24.8414 21.767 24.8492 21.8041 24.849 21.8415V24.0694C24.849 24.123 24.8326 24.1754 24.802 24.2195C24.7714 24.2636 24.7281 24.2973 24.6779 24.3161L23.5482 24.7361C19.9061 26.0747 17.275 27.0459 16.5054 28.585C15.8258 29.9876 15.4491 31.5176 15.3999 33.0754C15.3999 33.2147 15.4552 33.3482 15.5537 33.4466C15.6521 33.5451 15.7856 33.6004 15.9249 33.6004H40.0726C40.2118 33.6004 40.3453 33.5451 40.4438 33.4466C40.5422 33.3482 40.5975 33.2147 40.5975 33.0754C40.5489 31.5162 40.1722 29.9847 39.492 28.5808Z",
    fill: "#C9B3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3999,
    y: 39.2002,
    width: 25.2,
    height: 2.8,
    fill: "#C9B3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3999,
    y: 44.7998,
    width: 16.8,
    height: 2.8,
    fill: "#C9B3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.5cf30d8ee4245f620d899041cb986f89.svg";
export { ForwardRef as ReactComponent };